import { render, staticRenderFns } from "./WelcomeNext.vue?vue&type=template&id=332ea3a2&scoped=true&"
import script from "./WelcomeNext.vue?vue&type=script&lang=js&"
export * from "./WelcomeNext.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeNext.vue?vue&type=style&index=0&id=332ea3a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332ea3a2",
  null
  
)

export default component.exports